import { NodeEditor, Engine } from "rete";
// import MinimapPlugin from "rete-minimap-plugin";
import ConnectionPlugin from "rete-connection-plugin";
import VueRenderPlugin from "rete-vue-render-plugin";
import AreaPlugin from "rete-area-plugin";
import { notifyFactory } from "@/utils";

export async function initialize(
  container,
  component,
  connOptions = {},
  renderOptions = {}
) {
  const editor = new NodeEditor("retejs@0.1.0", container);

  // editor.use(MinimapPlugin);
  editor.use(ConnectionPlugin, connOptions);
  editor.use(VueRenderPlugin, renderOptions);

  const engine = new Engine("retejs@0.1.0");

  editor.on(
    "process nodecreated noderemoved connectioncreated connectionremoved",
    async () => {
      if (editor.silent) return;

      await engine.abort();
      await engine.process(editor.toJSON());
    }
  );

  editor.on("warn", async msg => {
    const notCompatibleSockets =
      msg.toString().indexOf("Sockets not compatible") > -1;

    if (notCompatibleSockets) {
      const title = "Несовместимые типы данных";
      const message = "Невозможно соединить блоки с разными типами данных.";
      component.$notify(notifyFactory("warning", title, message));
    }
  });

  return {
    editor,
    engine,
    resize() {
      editor.view.resize();
      AreaPlugin.zoomAt(editor);
    },
    process() {
      editor.trigger("process");
    }
  };
}
